module.exports = __webpack_public_path__ + "media/images/icons/facebook_share_dark-5fe335491be1a093c337b81a02247920.svg";